export default {
  mount: '.icon-remove',
  attrs: {
    viewBox: '0 0 24 24',
    fill: 'currentColor'
  },
  path: `<polygon points="19 13 5 13 5 11 19 11"></polygon>
  `
}
